import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { Progress } from './ui/progress';
import { Users, TrendingUp } from 'lucide-react';
import { mockTeamMembers } from '../mock/mockData';

const TeamManagement = () => {
  return (
    <div className="flex-1 overflow-y-auto bg-gray-50">
      <div className="bg-white border-b border-gray-200 px-8 py-6">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Team Management</h1>
        <p className="text-gray-600">Monitor team performance and workload distribution</p>
      </div>

      <div className="p-8 space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <Card>
            <CardContent className="pt-6">
              <div className="flex items-center justify-between">
                <Users className="w-8 h-8 text-blue-600" />
                <Badge variant="secondary">Active</Badge>
              </div>
              <p className="text-3xl font-bold mt-4">{mockTeamMembers.length}</p>
              <p className="text-sm text-gray-600 mt-1">Team Members</p>
            </CardContent>
          </Card>

          <Card>
            <CardContent className="pt-6">
              <div className="flex items-center justify-between">
                <TrendingUp className="w-8 h-8 text-green-600" />
                <Badge className="bg-green-100 text-green-700">+15%</Badge>
              </div>
              <p className="text-3xl font-bold mt-4">87%</p>
              <p className="text-sm text-gray-600 mt-1">Avg. Utilization</p>
            </CardContent>
          </Card>

          <Card>
            <CardContent className="pt-6">
              <div className="flex items-center justify-between">
                <Users className="w-8 h-8 text-purple-600" />
                <Badge variant="secondary">This Month</Badge>
              </div>
              <p className="text-3xl font-bold mt-4">70</p>
              <p className="text-sm text-gray-600 mt-1">Tasks Completed</p>
            </CardContent>
          </Card>
        </div>

        <Card>
          <CardHeader>
            <CardTitle>Team Workload</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-6">
              {mockTeamMembers.map((member) => (
                <div key={member.id} className="space-y-3">
                  <div className="flex items-center space-x-4">
                    <div className="w-12 h-12 rounded-full bg-gradient-to-br from-blue-500 to-blue-600 flex items-center justify-center text-white font-semibold">
                      {member.initials}
                    </div>
                    <div className="flex-1">
                      <h3 className="text-base font-semibold text-gray-900">
                        {member.name}
                      </h3>
                      <p className="text-sm text-gray-600">{member.role}</p>
                    </div>
                    <div className="flex items-center space-x-4 text-sm">
                      <div className="text-center">
                        <p className="font-semibold text-gray-900">{member.completed}</p>
                        <p className="text-xs text-gray-600">Done</p>
                      </div>
                      <div className="text-center">
                        <p className="font-semibold text-gray-900">{member.pending}</p>
                        <p className="text-xs text-gray-600">Pending</p>
                      </div>
                      {member.overdue > 0 && (
                        <div className="text-center">
                          <p className="font-semibold text-red-600">{member.overdue}</p>
                          <p className="text-xs text-red-600">Overdue</p>
                        </div>
                      )}
                    </div>
                  </div>
                  <div>
                    <div className="flex items-center justify-between mb-1">
                      <span className="text-sm text-gray-600">Workload</span>
                      <span className="text-sm font-semibold text-gray-900">
                        {member.workload}%
                      </span>
                    </div>
                    <Progress value={member.workload} className="h-2" />
                  </div>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default TeamManagement;
